import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { MiniCartComponent, MiniCartComponentService } from '@spartacus/cart/base/components/mini-cart';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, pairwise, startWith, tap } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
@Component({
  selector: 'app-mini-cart',
  templateUrl: './mini-cart.component.html',
  styleUrls: ['./mini-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShimanoMiniCartComponent extends MiniCartComponent implements OnInit, OnDestroy {
  isCartLoading = true;
  timeOut: any = null;
  miniCartLoadingSubscription$: Subscription;
  placeOrderItemsSubscription$: Subscription;
  languageSubscription$: Subscription;

  quantity$: Observable<number> = this.activeCartFacade.getActive().pipe(
    startWith({ totalItems: 0 }),
    map((cart) => {
      if (!(this.cdr as ViewRef).destroyed) {
        this.isCartLoading = false;
        this.cdr.detectChanges();
      }
      return cart.totalItems || 0;
    })
  );
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected miniCartComponentService: MiniCartComponentService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private languageService: ShimanoLanguageService,
    public deviceDetectorService: DeviceDetectorService
  ) {
    super(miniCartComponentService);
  }

  ngOnInit() {
    this.timeOut = setTimeout(() => {
      this.isCartLoading = false;
      this.cdr.detectChanges();
    });
    this.miniCartLoadingSubscription$ = this.componentService.updateMiniCart$.subscribe((status) => {
      this.isCartLoading = status;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });

    this.languageSubscription$ = combineLatest([
      this.activeLanguage$.pipe(pairwise()),
      this.componentService.updateMiniCart$,
    ])
      .pipe(
        tap(([activeLang, miniCartValue]) => {
          const [prevLanguage, currentLanguage] = activeLang;
          const updateCartLoading = prevLanguage !== currentLanguage && this.isCartLoading;
          if (updateCartLoading && miniCartValue) {
            this.isCartLoading = false;
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (this.miniCartLoadingSubscription$) {
      this.miniCartLoadingSubscription$.unsubscribe();
    }
    if (this.languageSubscription$) {
      this.languageSubscription$.unsubscribe();
    }
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
  }
}
